import React from 'react';
import { PageHeader, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ColumnsType } from 'antd/es/table';

import { formatDateTime } from '../../../utils/dateTimeUtil';
import Auction from '../../../core/models/Auction';
import { useGetPastAuctionsQuery } from '../../../app/api/auctionApiSlice';

const columns: ColumnsType<Auction> = [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    sorter: (a, b) => a.title.localeCompare(b.title),
  },
  {
    title: 'Auction Date',
    dataIndex: 'auctionDate',
    key: 'auctionDate',
    render: (date: string) => {
      return <>{formatDateTime(date)}</>;
    },
    sorter: (a, b) => new Date(a.auctionDate).getTime() - new Date(b.auctionDate).getTime(),
  },
  {
    title: 'Status',
    dataIndex: ['status', 'status'],
    key: 'status',
  },
  {
    title: 'Created On',
    dataIndex: 'createdDate',
    key: 'createdDate',
    render: (date: string) => {
      return <>{formatDateTime(date)}</>;
    },
    sorter: (a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
    defaultSortOrder: 'descend',
  },
];

const PastAuctions: React.FC = () => {
  const navigate = useNavigate();
  const { data: auctions, isLoading } = useGetPastAuctionsQuery();

  return (
    <>
      <PageHeader className='site-page-header' title='Auctions' />
      <Table
        sortDirections={['descend', 'ascend']}
        dataSource={auctions ?? []}
        columns={columns}
        rowKey='id'
        loading={isLoading}
        size='small'
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              navigate(`/auctions/${record.id}`);
            },
          };
        }}
      />
    </>
  );
};

export default PastAuctions;
